import axios from 'axios';
import _ from 'lodash';
import router from '@/router';
import store from '../store';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(
  config => {
    if (config.method !== 'get') {
      store.dispatch('addHttpRequest');
    }
    if (config.url !== 'oauth/token' && store.getters.UserIsAuthenticated) {
      _.merge(config.headers, {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      });
    }
    return config;
  },
  error => {
    if (error.config.method !== 'get') {
      store.dispatch('removeHttpRequest');
    }
    if (error.response.status === 401) {
      localStorage.removeItem('access_token');
      router.go('/login');
    } else {
      Promise.reject(error);
    }
  }
);

api.interceptors.response.use(
  response => {
    if (response.config.method !== 'get') {
      store.dispatch('removeHttpRequest');
    }
    if (response.status === 200 && response.headers['content-type'].startsWith('application/json')) {
      if (response.data.access_token) {
        localStorage.setItem('access_token', response.data.access_token);
      }
      if (response.data.payload) {
        response.data = response.data.payload;
      }
    }
    return response;
  },
  error => {
    if (error.config.method !== 'get') {
      store.dispatch('removeHttpRequest');
    }

    if (error.config.url === 'register') {
      return Promise.reject(new Error(JSON.stringify(error.response.data.error)));
    } else {
      return Promise.reject(error);
    }
  }
);

export default api;
